export default "__VITE_ASSET__zlckXt4t__"